"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NODE_LABEL_TO_KIND = exports.DiagramLabelToKindDict = void 0;

var node_labels_1 = require("./node-labels");

var node_kinds_1 = require("./node-kinds");

var DiagramLabelToKindDict =
/** @class */
function () {
  function DiagramLabelToKindDict() {
    this._dict = {};

    for (var _i = 0, NODE_KINDS_1 = node_kinds_1.NODE_KINDS; _i < NODE_KINDS_1.length; _i++) {
      var kind = NODE_KINDS_1[_i];
      var label = node_labels_1.NODE_LABELS.get(kind);
      this._dict[kind] = kind;
      this._dict[label] = kind;
    }
  }

  DiagramLabelToKindDict.prototype.get = function (label) {
    var kind = this._dict[label];

    if (kind) {
      return kind;
    }

    throw new Error("Could not resolve node kind label: " + label);
  };

  return DiagramLabelToKindDict;
}();

exports.DiagramLabelToKindDict = DiagramLabelToKindDict;
exports.NODE_LABEL_TO_KIND = new DiagramLabelToKindDict();